export default (() => {

    function throwError (context = 'no context', message = 'no message') {
        throw new Error(`${context} - ${message}`); 
    }

    return {throwError};

})();